
import './App.css';
import Navbar from './modules/Navbar';
import Landingpage from './pages/Landingpage';
import Service from './pages/Service';
import Reason from './pages/WhyChooseUs.jsx';
import Works from './pages/Works.jsx';
import TestimonialsSection from './pages/TestimonialsSection.jsx';
import ProjectGallery from './pages/Projectgallery';
import Footer from './modules/Footer.jsx';
import AboutUs from './pages/About.jsx';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Landingpage/>
      <Service />
      <Reason/>
      <Works/>
      <TestimonialsSection/>
      <ProjectGallery/>
      <AboutUs/>
      <Footer/>
    </div>
  );
}

export default App;
 